export const LOGGER_NAME = 'zipy';
export const ZIPY_SDK_URL = 'https://cdn.zipy.ai/sdk/v1.0/zipy.min.umd.js';
